import React from "react";
import DashboardMain from "../components/dashboard/DashboardMain";

const Dashboard = () => {
  return <DashboardMain />;
};

export default Dashboard;
